import { useState } from "react";
import moment from "moment";
import Select from "react-select";
import { ReactSVG } from "react-svg";
import exporticon from "../../../assets/images/export-icon.svg";
import TelerikReporting from "../../../components/TelerikReporting/TelerikReporting";
import useReports from "../../../Hooks/useReports";
import Loading from "../../../components/LoadingPage/Loading";
// import ReportHeader from "../../../components/reportHeader/ReportHeader";

const providerStatusList = [
  { label: "Active", value: true },
  { label: "Inactive", value: false },
];

const LocationsList = () => {
  const [reportKey, setReportKey] = useState(0);
  const [isActive, setIsActive] = useState({ label: "Active", value: true });
  const { locationListExportAPI, locationListExportLoading } = useReports();

  const handleStatusChange = (selectedOption: any) => {
    setIsActive(selectedOption);
    setReportKey((prevKey) => prevKey + 1);
  };

  const handleLocationListExport = async () => {
    try {
      const response = await locationListExportAPI({ isActive: isActive.value });
      if (!response) return;

      const blobUrl = URL.createObjectURL(response);
      const fileName = `${localStorage.getItem("profileClientId")?.toUpperCase() ?? "SRX"}_Locations_List_${moment().format("YYYYMMDD_HHmmss")}.xlsx`;

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Location List Export Failed:", error);
    }
  };

  return (
    <div className="report-content-wrapper">
      {/* <ReportHeader reportTitle="SRX Report - List of Locations" /> */}
      <div className="report-filter-wrapper">
        <div className="report-filter-item-wrapper">
          {locationListExportLoading && <Loading />}

          <div className="filter-item-box">
            <label className="form-label">Status</label>
            <Select
              classNamePrefix="react-select"
              options={providerStatusList}
              value={isActive}
              onChange={handleStatusChange}
              placeholder="Select Status"
              isDisabled={locationListExportLoading}
            />
          </div>
        </div>

        <div className="report-export-box">
          <button
            type="button"
            className="report-export-btn"
            onClick={handleLocationListExport}
            disabled={locationListExportLoading}
          >
            <ReactSVG className="svg-box" wrapper="span" src={exporticon} /> Export
          </button>
        </div>
      </div>

      <div className="filter-detail-wrapper">
        <div className="filter-item-detail-wrapper">
          <div className="filter-item-detail-title">
            <h4></h4>
          </div>
          <div className="locationlist-report-wrapper">
            <TelerikReporting
              key={reportKey}
              params={{ isActive: isActive?.value }}
              reportName="ListOfLocations.trdp"
              reportEndPoint="reports/listoflocations/get"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationsList;